import React from 'react'
import ContactOptions from './ContactOptions/ContactOptions'
import ContactUsForm from './ContactUsForm/ContactUsForm'

const ContactUs = () => {
    return (
        <div id='contactTop'>
            <ContactOptions />
            <ContactUsForm />
        </div>
    )
}

export default ContactUs